<template>
  <div class="tabs">
    <span class="tab" v-for="item in tabList" :key="item.id" :class="{'active-tab': activeTab === item.id}" @click="changeTab(item.id)">{{item.name}}</span>
  </div>
</template>

<script>

export default {
  props: {
    tabList: Array,
    changeTab: Function,
    activeTab: Number,
  },
  data() {
    return {
    }
  },
  methods: {
  }
}

</script>

<style lang="scss" scoped>
.tabs {
  float: left;
  margin-top: 13px;
  >span:first-child {
    border-radius: 4px 0px 0px 0px;
  }
  > span:nth-child(2) {
    margin-left: -5px;
  }
  > span:last-child {
    border-radius: 0px 4px 0px 0px;
    margin-left: -5px;
  }
}
.tab {
  width: 60px;
  height: 22px;
  background: #73818C;
  color: #fff;
  padding: 6px 18px;
  cursor: pointer;
}
.active-tab {
  background: #A4B4C1;
}
</style>



// WEBPACK FOOTER //
// src/components/tabs/tabs.vue